import { render, staticRenderFns } from "./MultipleIntegrationHooks.vue?vue&type=template&id=981c271c&scoped=true&"
import script from "./MultipleIntegrationHooks.vue?vue&type=script&lang=js&"
export * from "./MultipleIntegrationHooks.vue?vue&type=script&lang=js&"
import style0 from "./MultipleIntegrationHooks.vue?vue&type=style&index=0&id=981c271c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981c271c",
  null
  
)

export default component.exports